import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { queryKeys } from "../lib/queryKeys";
import { mrpService } from "../services/svc_mrp";

export const useTSQLowStock = (enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.mrp.list(),
    queryFn: () => mrpService.list(),
    enabled: enabled,
  });
};
